import { render, staticRenderFns } from "./tm-cookie-policy-page.vue?vue&type=template&id=86540c7c&scoped=true&"
import script from "./tm-cookie-policy-page.vue?vue&type=script&lang=ts&"
export * from "./tm-cookie-policy-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86540c7c",
  null
  
)

export default component.exports